import initCore from './initCore';
import initHeader from './header';
import initModals from './initModals';
import initNotifications from './newNotifications';
import initPopover from './initPopover';
import initHeaderNav from './initHeaderNav';
import initDeferredStyles from './initDeferredStyles';
import { initTracking } from '../tracking/initTracking';
import initClientSideNotifications from './initClientSideNotifications';
import initLogLanguageMismatch from './initLogLanguageMismatch';

[
  initCore,
  initHeader,
  initModals,
  initPopover,
  initNotifications,
  initHeaderNav,
  initTracking,
  initClientSideNotifications,
  initDeferredStyles,
  initLogLanguageMismatch,
].forEach((fn) => fn(window, document));
